/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { ChangeSuperAdminPasswordDto } from '../models/ChangeSuperAdminPasswordDto';
import type { CharityTenantKeyCreatedDto } from '../models/CharityTenantKeyCreatedDto';
import type { CharityTenantKeyDto } from '../models/CharityTenantKeyDto';
import type { CreateCharityTenantKeyDto } from '../models/CreateCharityTenantKeyDto';
import type { PasswordChangeResponseDto } from '../models/PasswordChangeResponseDto';
import type { RevokeCharityTenantKeyResponseDto } from '../models/RevokeCharityTenantKeyResponseDto';
import type { SuperAdminProfileDto } from '../models/SuperAdminProfileDto';
import type { UpdateSuperAdminProfileDto } from '../models/UpdateSuperAdminProfileDto';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class SuperAdminService {
    constructor(public readonly http: HttpClient) {}
    /**
     * Get super admin profile information
     * @returns SuperAdminProfileDto Super admin profile retrieved successfully.
     * @throws ApiError
     */
    public superAdminProfileControllerGetSuperAdminProfile(): Observable<SuperAdminProfileDto> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/super-admin/profile',
            errors: {
                403: `Access denied.`,
                404: `User not found.`,
            },
        });
    }
    /**
     * Update super admin profile information
     * @param requestBody
     * @returns SuperAdminProfileDto Super admin profile updated successfully.
     * @throws ApiError
     */
    public superAdminProfileControllerUpdateSuperAdminProfile(
        requestBody: UpdateSuperAdminProfileDto,
    ): Observable<SuperAdminProfileDto> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/super-admin/profile',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid input data or email already exists.`,
                403: `Access denied.`,
                404: `User not found.`,
            },
        });
    }
    /**
     * Change super admin password
     * Allows super admins to change their own password.
     * @param requestBody
     * @returns PasswordChangeResponseDto Password changed successfully.
     * @throws ApiError
     */
    public superAdminProfileControllerChangeSuperAdminPassword(
        requestBody: ChangeSuperAdminPasswordDto,
    ): Observable<PasswordChangeResponseDto> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/super-admin/profile/change-password',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid password or validation failed.`,
                403: `Access denied.`,
                404: `User not found.`,
            },
        });
    }
    /**
     * Generate a new tenant API key for a charity
     * Creates a new API key that can be used by the charity to access public endpoints. The full key is only returned once at creation time.
     * @param charityId The UUID of the charity
     * @param requestBody Data for creating a tenant key
     * @returns CharityTenantKeyCreatedDto Tenant key created successfully. The full key is only shown once.
     * @throws ApiError
     */
    public superAdminTenantKeysControllerCreateTenantKey(
        charityId: string,
        requestBody: CreateCharityTenantKeyDto,
    ): Observable<CharityTenantKeyCreatedDto> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/super-admin/charities/{charityId}/tenant-keys',
            path: {
                'charityId': charityId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid input data.`,
                403: `Access denied.`,
                404: `Charity not found.`,
            },
        });
    }
    /**
     * Get all tenant API keys for a charity
     * Returns all tenant keys for the specified charity. Keys are masked for security.
     * @param charityId The UUID of the charity
     * @returns CharityTenantKeyDto List of tenant keys retrieved successfully.
     * @throws ApiError
     */
    public superAdminTenantKeysControllerGetTenantKeys(
        charityId: string,
    ): Observable<Array<CharityTenantKeyDto>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/super-admin/charities/{charityId}/tenant-keys',
            path: {
                'charityId': charityId,
            },
            errors: {
                403: `Access denied.`,
                404: `Charity not found.`,
            },
        });
    }
    /**
     * Get a specific tenant API key
     * Returns details of a specific tenant key. Key is masked.
     * @param charityId The UUID of the charity
     * @param keyId The UUID of the tenant key
     * @returns CharityTenantKeyDto Tenant key retrieved successfully.
     * @throws ApiError
     */
    public superAdminTenantKeysControllerGetTenantKey(
        charityId: string,
        keyId: string,
    ): Observable<CharityTenantKeyDto> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/super-admin/charities/{charityId}/tenant-keys/{keyId}',
            path: {
                'charityId': charityId,
                'keyId': keyId,
            },
            errors: {
                400: `Tenant key does not belong to the specified charity.`,
                403: `Access denied.`,
                404: `Tenant key or charity not found.`,
            },
        });
    }
    /**
     * Delete a tenant API key
     * Permanently deletes a tenant key. Use revoke if you want to preserve the audit trail.
     * @param charityId The UUID of the charity
     * @param keyId The UUID of the tenant key to delete
     * @returns void
     * @throws ApiError
     */
    public superAdminTenantKeysControllerDeleteTenantKey(
        charityId: string,
        keyId: string,
    ): Observable<void> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/api/super-admin/charities/{charityId}/tenant-keys/{keyId}',
            path: {
                'charityId': charityId,
                'keyId': keyId,
            },
            errors: {
                400: `Tenant key does not belong to the specified charity.`,
                403: `Access denied.`,
                404: `Tenant key or charity not found.`,
            },
        });
    }
    /**
     * Revoke a tenant API key
     * Revokes an active tenant key, making it unusable. The key record is preserved for audit purposes.
     * @param charityId The UUID of the charity
     * @param keyId The UUID of the tenant key to revoke
     * @returns RevokeCharityTenantKeyResponseDto Tenant key revoked successfully.
     * @throws ApiError
     */
    public superAdminTenantKeysControllerRevokeTenantKey(
        charityId: string,
        keyId: string,
    ): Observable<RevokeCharityTenantKeyResponseDto> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/super-admin/charities/{charityId}/tenant-keys/{keyId}/revoke',
            path: {
                'charityId': charityId,
                'keyId': keyId,
            },
            errors: {
                400: `Key already revoked or does not belong to the charity.`,
                403: `Access denied.`,
                404: `Tenant key or charity not found.`,
            },
        });
    }
}
